export default {
  paged: {
    select: 'id,messageType,to,subject,deliveryProvider,created,responseCode',
    searchSelect: ['to', 'subject'],
  },
  item: {
    select:
      'id,messageType,from,replyTo,to,cc,bcc,subject,deliveryProvider,responseCode,errorMessage,created',
    expand: {
      processInstance: { select: 'name' },
      user: { select: 'fullName' },
    },
  },
};
